import * as React from "react";

import * as moment from "moment";

import { Appointment, WorkingHours } from "./models";
import { Week } from "./Week";

interface Props {
    entityId?: string;
    startDate: moment.Moment;
    appointments?: Appointment[];
    workingHours?: WorkingHours;
    onAppointmentClick?: (appointment: Appointment) => void;
    onAppointmentDrop?: (itemId: string, appointment: Appointment) => void;
    onHourDrop?: (itemId: string, hour: moment.Moment, entityId: string) => void;
    onHourClick?: (hour: moment.Moment, entityId: string) => void;
}

interface State {
    scrolled: boolean;
}

const hourHeight = 60;

export class EntityWeekView extends React.Component<Props, State> {
    private calendarContent: React.RefObject<HTMLDivElement>;

    constructor(props: Props) {
        super(props);
        this.state = { scrolled: false };
        this.calendarContent = React.createRef();
    }

    public render() {
        const date = this.props.startDate;

        const days: moment.Moment[] = [];
        while (days.length < 7) {
            days.push(date.clone().add(days.length, "days"));
        }

        const hours: moment.Moment[] = [];
        while (hours.length < 24) {
            hours.push(date.clone().add(hours.length, "hours"));
        }

        return (
            <>
                <div className="week day-headers">
                    <div className="hour-label" />
                    {days.map(day => <div className="day-header" key={day.valueOf()}>{day.format("ddd Do")}</div>)}
                </div>
                <div className="week calendar-content" ref={this.calendarContent} onScroll={() => this.setState({ scrolled: true })}>
                    <div className="hour-labels">
                        {/* eslint-disable-next-line react/forbid-dom-props */}
                        {hours.map(hour => <div key={hour.valueOf()} className="hour-label" style={{ height: hourHeight }}>{hour.format("HH:mm")}</div>)}
                    </div>
                    <Week
                        appointments={this.props.appointments}
                        days={days}
                        hourHeight={hourHeight}
                        entityId={this.props.entityId}
                        workingHours={this.props.workingHours}
                        onAppointmentClick={this.props.onAppointmentClick}
                        onAppointmentDrop={this.props.onAppointmentDrop}
                        onHourDrop={this.props.onHourDrop}
                        onHourClick={this.props.onHourClick}
                    />
                </div>
            </>
        );
    }

    public componentDidUpdate() {
        const domNode = this.calendarContent.current;
        if (!this.state.scrolled && domNode.scrollTo) {
            if (this.props.workingHours) {
                domNode.scrollTo(0, moment(this.props.workingHours.workingDayStartTime, "HH:mm").hour() * hourHeight - hourHeight);
            } else {
                domNode.scrollTo(0, 7 * hourHeight);
            }
        }
    }
}
